// extracted by mini-css-extract-plugin
var _1 = "UserMenuName-modulelist__VUGzs List-moduleList__p8DRk";
var _2 = "UserMenuName-moduleuserName__fs9_Z";
var _3 = "UserMenuName-modulewrapper__x2EUf";
export { _1 as "list", _2 as "userName", _3 as "wrapper" }
